
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 0a6.003 6.003 0 00-6 6 6.003 6.003 0 006 6 6.002 6.002 0 006-6 6.002 6.002 0 00-6-6zm4.674 3.857H8.63A7.786 7.786 0 007.11.98a5.162 5.162 0 013.563 2.878zm-4.698 7.084a6.948 6.948 0 01-1.712-2.798h3.472A6.95 6.95 0 016.02 10.94a.039.039 0 01-.045 0zM4.048 7.286a7.08 7.08 0 010-2.572h3.904a7.08 7.08 0 010 2.572H4.048zM.858 6c-.001-.434.053-.866.162-1.286h2.158c-.14.852-.14 1.72 0 2.572H1.02A5.102 5.102 0 01.857 6zM6 1.05a.03.03 0 01.024 0 6.95 6.95 0 011.712 2.807H4.264A6.95 6.95 0 015.98 1.06.032.032 0 016 1.05zm2.822 3.664h2.158a5.16 5.16 0 010 2.572H8.822c.14-.852.14-1.72 0-2.572zM4.89.98a7.82 7.82 0 00-1.521 2.878H1.325A5.162 5.162 0 014.89.98zM1.326 8.143H3.37A7.786 7.786 0 004.89 11.02a5.162 5.162 0 01-3.563-2.878zm5.786 2.878a7.815 7.815 0 001.52-2.878h2.042A5.162 5.162 0 017.11 11.02h.002z","fill":"#575757"}})])
          )
        }
      }
    